import $ from 'jquery';
import _ from 'underscore';

$(function () {
  /* -------------------------------------------------------------------------------------
  計測処理系
  ------------------------------------------------------------------------------------- */
  $(window).on({
    load: function () {
      customClick();
    }
  });

  function getGetParams () {
    var result = {};
    if (window.location.search.length > 1) {
      // 最初の1文字 (?記号) を除いた文字列を取得する
      var query = window.location.search.substring(1);

      // クエリの区切り記号 (&) で文字列を配列に分割する
      var parameters = query.split('&');

      for (var i = 0; i < parameters.length; i++) {
        // パラメータ名とパラメータ値に分割する

        var element = parameters[ i ].split('=');
        var paramName = decodeURIComponent(element[0]);
        var paramValue = decodeURIComponent(element[1]);

        // パラメータ名をキーとして連想配列に追加する
        result[ paramName ] = paramValue;
      }
    }
    return result;
  }

  /* クリック計測
  ----------------------------------------------- */
  function customClick () {
    var userAgent = window.navigator.userAgent.toLowerCase();
    var appVersion = window.navigator.appVersion.toLowerCase();
    var chkIE9, woParam; // eslint-disable-line no-unused-vars
    if (userAgent.indexOf('msie') !== -1 && appVersion.indexOf('msie 10.') === -1) {
      woParam = 'scrollbars=yes,resizable=yes';
    } else {
      woParam = '';
    }

    var loc = location.href; // eslint-disable-line no-unused-vars, camelcase
    var exclude = '.page-anchor, .page-top, .slide-btn, .banner-btn, .mobile-menu, [href="#"], [rel="shadowbox"], .normal-link, #studio-map-menu li a, .hair-type-bloc a, #price-anchor-link a, .bx-controls a';
    var pageTitle = $('title').text();
    var domain = location.hostname;
    var getParams = getGetParams();
    if (getParams.s) {
      delete getParams.s;
    }
    var getParamsArray = _.map(getParams, function (val, key) {
      return key + '=' + val;
    });
    var param = getParamsArray.join('&');

    $('a').not(exclude).on('click', function () {
      var href = $(this).attr('href');
      var checkFlg = href.indexOf('?check=');
      var studioFlg = href.indexOf('?studio=');
      var studioListFlg = href.indexOf('/studio-list');
      var formFlg = href.indexOf('/contact');
      var telFlg = href.indexOf('tel:');
      var userTypeFlg = href.indexOf('?zm_user_type=');
      var paramURL1 = '';
      var paramURL2 = '';

      if (param !== undefined && param !== '') {
        paramURL1 = href + '&' + param;
        paramURL2 = href + '?' + param;
      } else {
        paramURL1 = href;
        paramURL2 = href;
      }

      // フォームの場合
      if (formFlg !== -1) {
        var elementTitle = $(this).attr('title');
        if (domain === 'www.mens-svenson.net') {
          dataLayer.push({ // eslint-disable-line no-undef
            'event': 'customClickEvent',
            'customEventCategory': 'CTA',
            'customEventAction': 'Click',
            'customEventLabel': pageTitle + ' -- ' + elementTitle
          });
        }
        if (checkFlg === -1) {
          if (studioFlg === -1) {
            window.open(paramURL2, '_blank', woParam);
          } else {
            window.open(paramURL1, '_blank', woParam);
          }
        } else {
          window.open(paramURL1, '_blank', woParam);
        }
        return false;
      } else if (telFlg !== -1) { // 電話番号の場合
        if (domain === 'www.mens-svenson.net') {
          dataLayer.push({ // eslint-disable-line no-undef
            'event': 'customClickEvent',
            'customEventCategory': 'Tel',
            'customEventAction': 'Click',
            'customEventLabel': pageTitle + ' -- ' + href
          });
        }
      } else { // その他
        if ($(this).hasClass('gmenu-link') && domain === 'www.mens-svenson.net') {
          var elementText = $(this).text();
          dataLayer.push({ // eslint-disable-line no-undef
            'event': 'customClickEvent',
            'customEventCategory': 'Menu',
            'customEventAction': 'Click',
            'customEventLabel': elementText
          });
        }
        if ($(this).hasClass('click-ev_service') && domain === 'www.mens-svenson.net') {
          var serviceTitle = $(this).attr('title');
          dataLayer.push({ // eslint-disable-line no-undef
            'event': 'customClickEvent',
            'customEventCategory': 'Service',
            'customEventAction': 'Click',
            'customEventLabel': serviceTitle
          });
        }
        if ($(this).hasClass('click-ev_slider') && domain === 'www.mens-svenson.net') {
          var sliderTitle = $(this).children('img').attr('alt');
          dataLayer.push({ // eslint-disable-line no-undef
            'event': 'customClickEvent',
            'customEventCategory': 'Slider',
            'customEventAction': 'Click',
            'customEventLabel': sliderTitle
          });
        }
        if ($(this).hasClass('click-ev_hls') && domain === 'www.mens-svenson.net') {
          var hlsTitle = $(this).attr('title');
          dataLayer.push({ // eslint-disable-line no-undef
            'event': 'customClickEvent',
            'customEventCategory': 'HairLifeSolution',
            'customEventAction': 'Click',
            'customEventLabel': hlsTitle
          });
        }
        if ($(this).hasClass('click-ev_index-more') && domain === 'www.mens-svenson.net') {
          var moreTitle = $(this).attr('title');
          dataLayer.push({ // eslint-disable-line no-undef
            'event': 'customClickEvent',
            'customEventCategory': 'Index More',
            'customEventAction': 'Click',
            'customEventLabel': moreTitle
          });
        }
        if ($(this).attr('target') === '_blank') {
          window.open(paramURL2, '_blank', woParam);
        } else {
          location.href = paramURL2;
        }
        if (studioListFlg !== -1) {
          if (userTypeFlg !== -1) {
            location.href = paramURL1;
          } else {
            location.href = paramURL2;
          }
        }
        return false;
      }
    });
  }
});



// WEBPACK FOOTER //
// ./src/js/original/customClick.js